<template>
    <v-container grid-list-md fluid>
        <v-row class="d-flex justify-space-between mb-1">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11">
                        <h2>Variation des capitaux propres</h2>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <v-tooltip location="bottom" text="Message">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-chat"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod ||
                            validated ||
                            loading ||
                            dataLoading ||
                            !accountingPeriod ||
                            (N_1AccountingPeriod &&
                                N_1AccountingPeriod.id &&
                                !N_1AccountingPeriod.closed)
                        "
                        @click.stop="validateCapitalChanges()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="
                            closedPeriod ||
                            loading ||
                            dataLoading ||
                            !accountingPeriod ||
                            (N_1AccountingPeriod &&
                                N_1AccountingPeriod.id &&
                                !N_1AccountingPeriod.closed)
                        "
                        @click="validateFunction()"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-btn
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                validateCapitalChanges('REVIEW');
                            "
                        />
                        <v-btn-icon
                            size="small"
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                validateCapitalChanges('REVIEW');
                            "
                        />
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>

                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            >
                            </v-btn-next>
                        </template>

                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>

                    <!-- pipe character is rendered with a border -->
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                            color:'{{secondary}}'
                        "
                    />

                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>

                        <v-list nav>
                            <v-list-item
                                @click="displayActivityDialog = true"
                                :title="`Afficher l'activité`"
                            >
                                <template #append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>

                            <v-list-item
                                v-if="acrId && accountingPeriod && !accountingPeriod.closed"
                                @click="deleteAuditCheckResults()"
                                :title="`Supprimer les commentaires et les validations`"
                            >
                                <template #append>
                                    <v-icon icon="$oss-trash" />
                                </template>
                            </v-list-item>

                            <v-list-item
                                v-else
                                class="d-flex align-center"
                                disabled
                                :title="`Supprimer les commentaires et les validations`"
                            >
                                <template #append>
                                    <v-icon size="small" icon="$oss-trash" />
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>
        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large" icon="$oss-warning" />
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <template
                v-else-if="
                    N_1AccountingPeriod && N_1AccountingPeriod.id && !N_1AccountingPeriod.closed
                "
            >
                <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-center mb-3">
                        <h3>
                            N-1 n'est pas clôturé : Mon dossier - Exercices - N-1 - Modifier -
                            Clôturer - Calculer les reports à nouveau
                        </h3>
                    </v-col>
                </v-row>
            </template>

            <template v-else>
                <v-row
                    no-gutters
                    v-if="accountingPeriod && accountingPeriod.closed"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large" icon="$oss-warning" />
                    <h3>Période clôturée</h3>
                </v-row>
                <v-card-subtitle
                    v-if="!N_1AccountingPeriod || !N_1AccountingPeriod.id"
                    class="py-2 px-4"
                >
                    <h3 class="yellow_custom--text">Premier exercice : pas de N-1</h3>
                </v-card-subtitle>

                <!-- // ********* expand : elements d'analyse -->
                <v-card-text elevation="0" v-else>
                    <v-card-title v-if="noData" style="color: #78c5c2" class="py-2 px-0">
                        <h4>Aucune écriture enregistrée</h4>
                    </v-card-title>

                    <div v-else style="background-color: white; border-radius: 25px" class="pa-5">
                        <v-row no-gutters class="px-4 d-flex align-center">
                            <!-- // ** title ************** -->
                            <v-col cols="11" class="title font-weight-bold">
                                &#xc9;léments d'analyse
                            </v-col>

                            <v-spacer />

                            <!-- // ** icons *************** -->
                            <v-col cols="1" class="d-flex align-center justify-center pr-5">
                                <v-row>
                                    <v-col cols="6" class="d-flex align-center">
                                        <v-icon
                                            v-if="validated"
                                            color="primary"
                                            size="large"
                                            icon="$check_circle"
                                        />
                                    </v-col>

                                    <!-- // ** expand icon -->
                                    <v-col cols="6" class="d-flex align-center">
                                        <v-btn-icon
                                            :icon="
                                                showTable ? '$fa-chevron-up' : '$fa-chevron-down'
                                            "
                                            @click="showTable = !showTable"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-expand-transition>
                            <div v-show="showTable">
                                <v-card-text>
                                    <v-data-table
                                        v-model:expanded="expanded"
                                        :headers="capitalAccountableAccountsHeaders"
                                        :items="groupedAccountableAccounts"
                                        item-value="groupName"
                                        :loading="loading"
                                        class="table"
                                        style="border: 1px #ededed solid"
                                        :items-per-page="-1"
                                    >
                                        <template #no-data>Aucune charge à réintégrer</template>

                                        <template v-slot:item="props">
                                            <tr>
                                                <!-- // ** groupName -->
                                                <td
                                                    cols="auto"
                                                    v-if="props.item.groupName"
                                                    class="text-left"
                                                >
                                                    {{ props.item.groupName }}
                                                </td>

                                                <!-- // ** groupDescription -->
                                                <td
                                                    v-if="props.item.groupDescription"
                                                    style="border-left: 1px solid #dddddd"
                                                    class="text-left"
                                                >
                                                    {{ props.item.groupDescription }}
                                                </td>

                                                <!-- // ** carryForward -->
                                                <td
                                                    v-if="props.item.carryForward"
                                                    style="
                                                        border-left: 1px solid #dddddd;
                                                        width: 100px;
                                                    "
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.carryForward,
                                                            { currency: "", DC: true },
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    v-else
                                                    style="
                                                        border-left: 1px solid #dddddd;
                                                        width: 100px;
                                                    "
                                                    class="text-right"
                                                >
                                                    -
                                                </td>

                                                <!-- // ** increases -->
                                                <td
                                                    v-if="props.item.increases"
                                                    class="text-right"
                                                    style="
                                                        border-left: 1px solid #dddddd;
                                                        width: 100px;
                                                    "
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.increases,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    v-else
                                                    class="text-right"
                                                    style="
                                                        border-left: 1px solid #dddddd;
                                                        width: 100px;
                                                    "
                                                >
                                                    -
                                                </td>

                                                <!-- // ** decreases -->
                                                <td
                                                    v-if="props.item.decreases"
                                                    style="
                                                        border-left: 1px solid #dddddd;
                                                        width: 170px;
                                                    "
                                                    class="text-right"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.decreases,
                                                            undefined,
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    v-else
                                                    class="text-right"
                                                    style="
                                                        border-left: 1px solid #dddddd;
                                                        width: 100px;
                                                    "
                                                >
                                                    -
                                                </td>

                                                <!-- // ** balance -->
                                                <td
                                                    v-if="props.item.balance"
                                                    style="
                                                        border-left: 1px solid #dddddd;
                                                        width: 170px;
                                                    "
                                                    class="text-right py-2;"
                                                >
                                                    {{
                                                        newCommonFormatCurrency(
                                                            props.item.balance,
                                                            { currency: "", DC: true },
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    v-else
                                                    class="text-right"
                                                    style="
                                                        border-left: 1px solid #dddddd;
                                                        width: 100px;
                                                    "
                                                >
                                                    -
                                                </td>

                                                <!-- // ** comment -->
                                                <td
                                                    style="
                                                        border-left: 1px solid #dddddd;
                                                        width: 170px;
                                                    "
                                                    class="text-center"
                                                >
                                                    <v-btn-icon
                                                        icon="
                                                            $add_circle_outline
                                                        "
                                                        v-if="
                                                            accountingPeriod &&
                                                            accountingPeriod.closed
                                                        "
                                                        disabled
                                                    />
                                                    <v-btn-icon
                                                        v-else-if="props.item.comment"
                                                        icon="$create"
                                                        @click="expandComment(props.item)"
                                                        color="primary"
                                                    >
                                                    </v-btn-icon>
                                                    <v-btn-icon
                                                        v-else
                                                        icon="
                                                            $add_circle_outline
                                                        "
                                                        @click="expandComment(props.item)"
                                                    />
                                                </td>

                                                <td
                                                    style="
                                                        border-left: 1px solid #dddddd;
                                                        width: 170px;
                                                    "
                                                    class="text-center"
                                                >
                                                    <!-- // ** {{validatedAccountableAccount}} -->
                                                    <v-btn
                                                        v-if="
                                                            disabledDetailsValidateBtn(props.item)
                                                        "
                                                        rounded
                                                        elevation="0"
                                                        disabled
                                                        :data-cy="
                                                            'CheckCapitalChanges-' +
                                                            props.item.groupName
                                                        "
                                                        size="small"
                                                    >
                                                        Valider
                                                    </v-btn>

                                                    <v-btn
                                                        v-else-if="!props.item.validated"
                                                        rounded
                                                        elevation="0"
                                                        @click="
                                                            props.item.validated =
                                                                !props.item.validated
                                                        "
                                                        :data-cy="
                                                            'CheckCapitalChanges-' +
                                                            props.item.groupName
                                                        "
                                                        size="small"
                                                    >
                                                        Valider
                                                    </v-btn>

                                                    <v-btn
                                                        v-else
                                                        rounded
                                                        elevation="0"
                                                        @click="
                                                            props.item.validated =
                                                                !props.item.validated
                                                        "
                                                        :data-cy="
                                                            'CheckCapitalChanges-' +
                                                            props.item.groupName
                                                        "
                                                        size="small"
                                                    >
                                                        Invalider
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </template>

                                        <template v-slot:expanded-row="{ columns, item }">
                                            <td
                                                colspan="100%"
                                                style="height: 120px; padding-top: 0; margin-top: 0"
                                            >
                                                <v-textarea
                                                    outlined
                                                    dense
                                                    v-model="item.comment"
                                                    :disabled="closedPeriod || validated"
                                                    style="
                                                        margin-right: auto;
                                                        margin-left: auto;
                                                        padding: 10px;
                                                        border: 1px #ededed solid;
                                                    "
                                                    @update:model-value="addComment(item)"
                                                    label="Commentaire"
                                                    data-cy="CheckCapitalChanges-commentaires"
                                                >
                                                </v-textarea>
                                            </td>
                                        </template>

                                        <template #body.append>
                                            <tr style="font-weight: bold">
                                                <th />

                                                <th>Totaux</th>

                                                <!-- // ** carryForward -->
                                                <th
                                                    v-if="sumsTable('carryForward')"
                                                    style="text-align: right"
                                                >
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                sumsTable("carryForward"),
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                    </h3>
                                                </th>
                                                <th v-else style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                sumsTable("carryForward"),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>

                                                <!-- // ** increases -->
                                                <th style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                sumsTable("increases"),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>

                                                <!-- // ** decreases -->
                                                <th style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                sumsTable("decreases"),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>

                                                <!-- // ** balance -->
                                                <th
                                                    v-if="sumsTable('balance')"
                                                    style="text-align: right"
                                                >
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                sumsTable("balance"),
                                                                { currency: "", DC: true },
                                                            )
                                                        }}
                                                    </h3>
                                                </th>
                                                <th v-else style="text-align: right">
                                                    <h3>
                                                        {{
                                                            newCommonFormatCurrency(
                                                                sumsTable("balance"),
                                                                undefined,
                                                            )
                                                        }}
                                                    </h3>
                                                </th>

                                                <th />

                                                <th />
                                            </tr>
                                        </template>
                                    </v-data-table>

                                    <!-- // ** Enregistrer valider btns -->
                                    <v-row>
                                        <v-spacer />

                                        <v-col cols="auto" class="pt-6">
                                            <v-row class="text-right">
                                                <!-- // ** OD -->
                                                <!-- <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="!accountingPeriod || (accountingPeriod && accountingPeriod.closed)"
                                                        rounded
                                                         size="small"

                                                        elevation="0"
                                                        disabled
                                                    >
                                                        OD
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                         size="small"

                                                        color="primary"
                                                        elevation="0"
                                                        @click="createRows(); miscellaneousOperationDialog=true;"
                                                    >
                                                        OD
                                                    </v-btn>
                                                </v-col> -->

                                                <!-- // ** enregistrer -->
                                                <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="closedPeriod || validated"
                                                        rounded
                                                        disabled
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                        elevation="0"
                                                        @click="validateCapitalChanges()"
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                </v-col>

                                                <!-- // ** si false > valider -->
                                                <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="closedPeriod"
                                                        rounded
                                                        elevation="0"
                                                        disabled
                                                        size="small"
                                                    >
                                                        <!-- {{$t('audit.validate')}} -->
                                                        Valider
                                                    </v-btn>

                                                    <v-btn
                                                        v-else-if="!validated"
                                                        rounded
                                                        elevation="0"
                                                        @click="validateAll()"
                                                        size="small"
                                                    >
                                                        <!-- {{$t('audit.validate')}} -->
                                                        Valider
                                                    </v-btn>

                                                    <!-- // ** si true > invalider -->
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                        elevation="0"
                                                        @click="unvalidateAll()"
                                                        data-cy="CheckCapitalChanges-unValid"
                                                        size="small"
                                                    >
                                                        Invalider
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </div>
                        </v-expand-transition>
                    </div>
                </v-card-text>

                <!-- // ********* resume accountableAccounts comments ********* -->
                <v-card-text v-if="!noData" elevation="0">
                    <div style="background-color: white; border-radius: 25px" class="pa-5">
                        <v-row no-gutters class="px-4 d-flex align-center">
                            <!-- // ** title ************** -->
                            <!-- <v-col cols="11" class="subtitle-2"> -->
                            <v-col cols="11" class="title font-weight-bold"> Synthèse </v-col>

                            <v-spacer />

                            <!-- // ** icons *************** -->
                            <v-col cols="1" class="d-flex align-center justify-center">
                                <v-row>
                                    <v-col cols="6" class="align-center">
                                        <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                    </v-col>

                                    <!-- // ** expand icon -->
                                    <v-col cols="6" class="align-center">
                                        <v-btn-icon
                                            :icon="
                                                showComments ? '$fa-chevron-up' : '$fa-chevron-down'
                                            "
                                            @click="
                                                createComments();
                                                showComments = !showComments;
                                            "
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-expand-transition no-gutters>
                                <div v-show="showComments" no-gutters>
                                    <v-card-text v-if="!comments || !comments.length" class="px-0">
                                        Aucun commentaire saisi
                                    </v-card-text>

                                    <template v-else>
                                        <v-card-text
                                            v-for="(comment, index) in comments"
                                            :key="index"
                                            class="px-0"
                                        >
                                            <h3 class="text-uppercase pb-1">{{ comment.title }}</h3>
                                            <div
                                                v-for="(commentLine, ic) in toArray(comment.text)"
                                                :key="ic"
                                                class="mb-0 px-0"
                                            >
                                                <p class="mb-0">{{ commentLine }}</p>
                                            </div>
                                        </v-card-text>
                                    </template>
                                </div>
                            </v-expand-transition>
                        </v-row>
                    </div>
                </v-card-text>

                <!-- // ** connectedDocuments -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriodId || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                </template>

                <!-- // ** results -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                </template>

                <!-- // ********* longComment  *********-->
                <v-card-text elevation="0">
                    <div style="background-color: white; border-radius: 25px" class="pa-5">
                        <v-row no-gutters class="px-4 d-flex align-center">
                            <v-col cols="11" class="title font-weight-bold">
                                Commentaires détaillés
                            </v-col>

                            <v-spacer />

                            <!-- // ** icons *************** -->
                            <v-col cols="1" class="d-flex align-center justify-center">
                                <v-row>
                                    <v-col cols="6" class="align-center">
                                        <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                    </v-col>

                                    <!-- // ** expand icon -->
                                    <v-col cols="6" class="align-center">
                                        <v-btn-icon
                                            :icon="
                                                showLongComment
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                            @click="showLongComment = !showLongComment"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-expand-transition no-gutters>
                            <div v-show="showLongComment" no-gutters>
                                <v-card-text>
                                    <v-textarea
                                        v-model="longComment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        class="pt-1"
                                        style="border: 1px #ededed solid"
                                        outlined
                                    />

                                    <v-row>
                                        <v-spacer />
                                        <v-col cols="auto" class="pt-6">
                                            <v-row class="text-right">
                                                <!-- // ** OD -->
                                                <!-- <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="!accountingPeriod || (accountingPeriod && accountingPeriod.closed)"
                                                        rounded
                                                         size="small"

                                                        elevation="0"
                                                        disabled
                                                    >
                                                        OD
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                         size="small"

                                                        color="primary"
                                                        elevation="0"
                                                        @click="createRows(); miscellaneousOperationDialog=true;"
                                                    >
                                                        OD
                                                    </v-btn>
                                                </v-col> -->

                                                <!-- // ** enregistrer -->
                                                <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="closedPeriod || validated"
                                                        rounded
                                                        disabled
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                        elevation="0"
                                                        @click="validateCapitalChanges()"
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                </v-col>

                                                <!-- // ** si false > valider -->
                                                <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="closedPeriod"
                                                        rounded
                                                        elevation="0"
                                                        disabled
                                                        size="small"
                                                    >
                                                        <!-- {{$t('audit.validate')}} -->
                                                        Valider
                                                    </v-btn>

                                                    <v-btn
                                                        v-else-if="!validated"
                                                        rounded
                                                        elevation="0"
                                                        @click="validateAll()"
                                                        size="small"
                                                    >
                                                        <!-- {{$t('audit.validate')}} -->
                                                        Valider
                                                    </v-btn>

                                                    <!-- // ** si true > invalider -->
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                        elevation="0"
                                                        @click="unvalidateAll()"
                                                        size="small"
                                                    >
                                                        Invalider
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </div>
                        </v-expand-transition>
                    </div>
                </v-card-text>

                <!-- // ********* shortComment ********* -->
                <v-card-text elevation="0">
                    <div style="background-color: white; border-radius: 25px" class="pa-5">
                        <v-row no-gutters class="px-4 d-flex align-center">
                            <!-- // ** title ************** -->
                            <v-col cols="11" class="title font-weight-bold">
                                Commentaires synthétiques
                            </v-col>

                            <v-spacer />

                            <!-- // ** icons *************** -->
                            <v-col cols="1" class="d-flex align-center justify-center">
                                <v-row>
                                    <v-col cols="6" class="align-center">
                                        <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                    </v-col>

                                    <!-- // ** expand icon -->
                                    <v-col cols="6" class="align-center">
                                        <v-btn-icon
                                            :icon="
                                                showShortComment
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                            @click="showShortComment = !showShortComment"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-expand-transition no-gutters>
                            <div v-show="showShortComment" no-gutters>
                                <v-card-text>
                                    <v-textarea
                                        v-model="shortComment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="border: 1px #ededed solid"
                                        outlined
                                    />
                                    <!-- :key="i" -->

                                    <!-- // ** Enregistrer valider btns -->
                                    <v-row>
                                        <v-spacer />

                                        <v-col cols="auto" class="pt-6">
                                            <v-row class="text-right">
                                                <!-- // ** OD -->
                                                <!-- <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="!accountingPeriod || (accountingPeriod && accountingPeriod.closed)"
                                                        rounded
                                                         size="small"

                                                        elevation="0"
                                                        disabled
                                                    >
                                                        OD
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                         size="small"

                                                        color="primary"
                                                        elevation="0"
                                                        @click="createRows(); miscellaneousOperationDialog=true;"
                                                    >
                                                        OD
                                                    </v-btn>
                                                </v-col> -->

                                                <!-- // ** enregistrer -->
                                                <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="closedPeriod || validated"
                                                        rounded
                                                        disabled
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                        elevation="0"
                                                        @click="validateCapitalChanges()"
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                </v-col>

                                                <!-- // ** si false > valider -->
                                                <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="closedPeriod"
                                                        rounded
                                                        elevation="0"
                                                        disabled
                                                        size="small"
                                                    >
                                                        <!-- {{$t('audit.validate')}} -->
                                                        Valider
                                                    </v-btn>

                                                    <v-btn
                                                        v-else-if="!validated"
                                                        rounded
                                                        elevation="0"
                                                        @click="validateAll()"
                                                        size="small"
                                                    >
                                                        <!-- {{$t('audit.validate')}} -->
                                                        Valider
                                                    </v-btn>

                                                    <!-- // ** si true > invalider -->
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                        elevation="0"
                                                        @click="unvalidateAll()"
                                                        size="small"
                                                    >
                                                        Invalider
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </div>
                        </v-expand-transition>
                    </div>
                </v-card-text>

                <!-- // ** GeneralLedger -->
                <v-card-text elevation="0" v-if="showGeneralLedgerCard">
                    <div style="background-color: white; border-radius: 25px" class="pa-5">
                        <v-row no-gutters class="px-4 d-flex align-center">
                            <v-col cols="5" class="title font-weight-bold">
                                Grand livre c/{{
                                    getTextFromStringArray(items.accountableAccountsRoot)
                                }}
                            </v-col>

                            <!-- <v-col v-if="noResults" cols="3" class="title font-weight-bold ">
                                Pas de comptes mouvementés
                            </v-col>
                            <v-col v-else cols="3" class="title font-weight-bold ">
                            </v-col> -->

                            <v-spacer />

                            <!-- // ** icons *************** -->
                            <v-col cols="1" class="d-flex align-center justify-center">
                                <v-row>
                                    <v-col cols="6" class="align-center">
                                        <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                    </v-col>

                                    <!-- // ** expand icon -->
                                    <v-col cols="6" class="align-center">
                                        <v-btn-icon
                                            :icon="
                                                generalLedgerExpand
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                            v-if="!noResults"
                                            @click="generalLedgerExpand = !generalLedgerExpand"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-card-text v-show="generalLedgerExpand" transition="expand">
                            <v-card
                                style="background-color: white; border-radius: 25px; padding: 10px"
                                class="my-5"
                            >
                                <v-card-text transition="expand">
                                    <!-- // // switchs generalLedger -->

                                    <v-row>
                                        <v-col>
                                            <GeneralLedger
                                                ref="generalLedger"
                                                :companyId="companyId"
                                                :accountingPeriodId="accountingPeriod.id"
                                                :accountableAccountFilter="
                                                    items.accountableAccountsRoot
                                                "
                                                :excludedAccountableAccountFilter="
                                                    items.excludedAccountableAccounts || []
                                                "
                                                :inNm1="false"
                                                @query-done="onQueryDone"
                                                :enableAuditedAccountableAccounts="true"
                                            />
                                            <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                        </v-col>
                                    </v-row>

                                    <!-- // ** OD -->
                                    <v-row>
                                        <v-col style="padding-bottom: 0">
                                            <v-card-title
                                                style="
                                                    padding-top: 20px;
                                                    padding-bottom: 0;
                                                    padding-left: 0;
                                                "
                                                class="d-flex justify-end"
                                            >
                                                <v-spacer />

                                                <v-btn
                                                    v-if="
                                                        accountingPeriod && accountingPeriod.closed
                                                    "
                                                    rounded
                                                    disabled
                                                    size="small"
                                                >
                                                    OD
                                                </v-btn>
                                                <v-btn
                                                    v-else
                                                    rounded
                                                    class="btn btn_blue"
                                                    @click="
                                                        validateCapitalChanges();
                                                        miscellanousOperationData = undefined;
                                                        miscellaneousOperationDialog = true;
                                                    "
                                                    size="small"
                                                >
                                                    OD
                                                </v-btn>
                                            </v-card-title>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <br />
                            </v-card>
                        </v-card-text>
                    </div>
                </v-card-text>
            </template>

            <!-- // ** dialog OD -->
            <!-- <v-dialog
                v-if="miscellaneousOperationDialog"
                v-model="miscellaneousOperationDialog"
                @keydown.esc="miscellaneousOperationDialog = false"
                width="90%"
            >
                <AccountingItemEdition
                    :companyId="companyId"
                    :accountingItemType="'MISCELLANEOUS_OPERATION'"
                    :prefilledRows="miscellanousOperationData"

                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="refresh()"
                    v-if="miscellaneousOperationDialog"
                ></AccountingItemEdition>
            </v-dialog> -->
            <oss-dialog
                v-model="miscellaneousOperationDialog"
                :actions="actionsMiscellaneousOperation"
                min-width="90vw"
            >
                <AccountingItemEdition2
                    v-if="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :prefilledRows="miscellanousOperationData"
                    :acKey="acKey"
                    :actions="actionsMiscellaneousOperation"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="refresh()"
                />
            </oss-dialog>
            <oss-dialog
                v-model="displayActivityDialog"
                v-if="displayActivityDialog"
                title="Activité"
                valid-title="Fermer"
                @valid="displayActivityDialog = false"
                @close="displayActivityDialog = false"
                min-width="60vw"
            >
                <UsersActivitiesHistory
                    :auditCheckKey="acKey"
                    :accountingPeriodId="accountingPeriodId"
                >
                </UsersActivitiesHistory>
            </oss-dialog>
            <Chat
                :auditCheckAccountingPeriodKey="chatId"
                v-if="openChat"
                v-bind:chatTitle="'Chat'"
            />
            <AuditCheckDocumentsManager
                v-model="dialogAuditCheckDocumentsManager"
                v-if="dialogAuditCheckDocumentsManager"
                :disabled="loading || dataLoading || !accountingPeriod"
                :companyId="companyId"
                :documentToDisplay="documentToDisplay"
                :connectedDocuments="connectedDocuments || []"
                :acKey="acKey"
                :auditCheckResult="auditCheckResult || {}"
                :accountingPeriodId="accountingPeriodId || undefined"
                :alreadyLinkedDoc="alreadyLinkedDoc"
                @upsertedAuditCheckResult="upsertedACR"
                @resetDialogData="
                    alreadyLinkedDoc = false;
                    documentToDisplay = {};
                "
            />
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { isEmpty } from "lodash";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { getTextFromStringArray } from "../../../../backend/src/common/audit/auditFunctions";
import { getN_1AccountingPeriod } from "../../services/accountingPeriods";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";
// import { getEmptyDocument } from "../../services/documentServices";
// import { remove } from 'lodash'

// //////////////////// APOLLO ////////////////////////
import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import DELETE_AUDIT_CHECK_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";

import GeneralLedger from "../GeneralLedger2.vue";
import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";
// import AccountableAccountBalanceDetail from '../AccountableAccountBalanceDetail.vue'
import { CheckBase } from "./CheckBase";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import Chat from "../chat/Chat.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import { getDBFormattedDate } from "@/services/dateServices";
import { DialogAction } from "@/services/dialogAction";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        GeneralLedger,
        AccountingItemEdition2,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
    },
})
export class CheckCapitalChanges extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) documentId: string;

    loading: boolean = false;
    dataLoading: boolean = true;
    refreshGeneralLedger: number = 0;

    dialogAuditCheckDocumentsManager: boolean = false;

    validated: boolean = false;

    showTable: boolean = true;
    showComments: boolean = false;
    showShortComment: boolean = false;
    showLongComment: boolean = false;
    showGeneralLedger: boolean = false;
    showGeneralLedgerCard: boolean = true;

    expand: boolean = false;
    expanded: Array<any> = [];
    generalLedgerExpand: boolean = false;

    accountingTransactions: Array<any> = [];
    withoutLettering: boolean = false;
    withoutBank: boolean = false;
    withoutDocument: boolean = false;

    company: any = {};

    auditCheckResultId: string = "";
    auditCheckResult: any = null;

    comments: Array<any> = [];
    shortComment: string = "";
    longComment: string = "";

    miscellanousOperationData: Array<any> = [];

    // ** dialogs
    miscellaneousOperationDialog: boolean = false;

    // * dates
    selectedDate: any = {};
    minDate: string = "";
    maxDate: string = "";

    // switchManual: boolean = false;
    // othersVatBasis: number = 0.0

    // ** acr
    acrId: string = "";
    acrData: any = {};
    acrResultDocuments: Array<any> = [];
    noResults: boolean = false;

    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    alreadyLinkedDoc: boolean = false;

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    // validatedCustomer: boolean = false;
    // ignoredCustomer: boolean = false;

    // get selectedCompany() {
    //     return this.$store.state.selected_company;
    // }

    // auditCheckKey: string = "Ts7v87qvdI1RYwhKkv9ptAGR";

    // ++++ The DatePicker needs a format 'YYYY-MM-DD' +++++
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    getTextFromStringArray(array: Array<string>) {
        return getTextFromStringArray(array);
    }

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    // ********** HEADERS - DUES SALES-INVOICES ***********
    capitalAccountableAccountsHeaders: Array<any> = [
        {
            title: "Comptes",
            value: "groupName",
            align: "left",
            width: "100px",
            sortable: false,
        },
        {
            title: "Postes",
            value: "groupDescription",
            align: "left",
            sortable: false,
        },
        {
            title: "N - 1",
            value: "carryForward",
            align: "right",
            width: "150px",
            sortable: false,
        },
        {
            title: "+",
            value: "increases",
            align: "right",
            width: "150px",
            sortable: false,
        },
        {
            title: "-",
            value: "decreases",
            align: "right",
            width: "150px",
            sortable: false,
        },
        {
            title: "N",
            value: "balance",
            align: "right",
            width: "150px",
            sortable: false,
        },
        {
            title: "Commentaire",
            value: "data-table-expand",
            align: "center",
            width: "100px",
            sortable: false,
        },
        {
            title: "Valider",
            value: "",
            align: "center",
            width: "100px",
            sortable: false,
        },
    ];

    get N_1AccountingPeriod() {
        if (this?.$store?.state?.accountingPeriod?.accountingPeriods?.length > 1) {
            return getN_1AccountingPeriod(
                this.$store.state.accountingPeriod,
                this.accountingPeriodId,
            );
        }
        return null;
    }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    // ***********************************************************
    // ********** APOLLO - errMessages - customers - globalAmounts ***
    @Apollo({
        // ** AUDIT_ITEMS
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId,
            };
            // accountingPeriodId: this.$route.params.accountingPeriodId ? this.$route.params.accountingPeriodId
        },
        skip() {
            return (
                !this.companyId ||
                !this.accountingPeriodId ||
                !this?.$store?.state?.accountingPeriod
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            // if (!loading && data && data.auditItems && data.auditItems.items && !data.auditItems.items.length) {
            //     debugger
            //     this.initialiseCompany()
            //     this.$router.go(-1)
            // } else if (!loading && data) {
            if (!loading && data) {
                this.dataLoading = true;
                if (data.auditItems && data.auditItems.items && !data.auditItems.items.length) {
                    this.items = undefined;
                } else if (data?.auditItems?.items?.[0]) {
                    this.items = data.auditItems.items[0];

                    this.groupedAccountableAccounts = this.items.output || [];
                    this.noData = this.items.noData || false;

                    this.createComments();

                    this.acrId = this.items.acrId || "";

                    this.acrData = !isEmpty(this.items.acrData) ? this.items.acrData : {};

                    if (this.items.auditCheckResult) {
                        this.auditCheckResult = this.items.auditCheckResult;

                        if (this.auditCheckResult.documents) {
                            this.connectedDocuments = this.auditCheckResult.documents;
                        }

                        if (this.auditCheckResult.results) {
                            this.results = this.auditCheckResult.results;
                        }

                        if (this.auditCheckResult.reviewed) {
                            this.reviewed = this.auditCheckResult.reviewed;
                        }
                    }

                    if (this.acrData?.global) {
                        this.shortComment = this.acrData.global.shortComment || "";

                        this.longComment = this.acrData.global.longComment || "";

                        this.validated = this.acrData.global.validated || false;
                    } else {
                        this.shortComment = "";
                        this.longComment = "";
                        this.validated = false;
                    }

                    // this.accountableAccounts = this.items.accountableAccounts || []
                } else {
                    this.items = [];
                }
                this.loading = loading;
                this.dataLoading = false;
            }
        },
    })
    items: any = {};

    groupedAccountableAccounts: Array<any> = [];

    noData: boolean = true;

    reviewed: number = 0;

    // accountableAccounts: Array<any> = []

    async validateCapitalChanges(action = undefined) {
        const groupedAccountableAccounts = JSON.parse(
            JSON.stringify(this.groupedAccountableAccounts),
        );
        // const groupedAccountableAccounts = JSON.parse(JSON.stringify(this.accountableAccounts))

        const defaultData: any = {
            global: {
                validated: false,
                shortComment: "",
                longComment: "",
            },
            details: [],
        };

        // ** il ne faut pas écraser data et results
        // ** mais récupérer et push
        const data = !isEmpty(this.acrData)
            ? JSON.parse(JSON.stringify(this.acrData))
            : JSON.parse(JSON.stringify(defaultData));

        data.global.validated = this.validated;
        data.global.shortComment = this.shortComment;
        data.global.longComment = this.longComment;

        for (const aa of groupedAccountableAccounts) {
            const aaData = {
                groupName: aa.groupName,
                groupDescription: aa.groupDescription,
                previousACR: {
                    carryForward: aa.carryForward,
                    totalDebit: aa.totalDebit,
                    totalCredit: aa.totalCredit,
                    balance: aa.balance,
                },
                validated: aa.validated || false,
                comment: aa.comment,
            };

            if (!isEmpty(this.acrData)) {
                const foundedAaAcrData = data.details?.length
                    ? data.details.findIndex((d) => d.groupName === aaData.groupName)
                    : -1;
                if (foundedAaAcrData >= 0) {
                    data.details[foundedAaAcrData] = aaData;
                } else {
                    data.details.push(aaData);
                }
            } else {
                // const foundedAaAcrData = data.details.findIndex(d => d.groupName === aa.groupName)
                // if (foundedAaAcrData >= 0) {
                //     data.details.splice(foundedAaAcrData, 1)
                // }
                data.details.push(aaData);
            }
        }

        const upsertVariables: any = {
            id: this.acrId || "",
            key: this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId,
            companyId: this.companyId,
            status: this.validated ? "VALIDATED" : "EDITION",
            // thirdPartyCompanyCreate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
            // thirdPartyCompanyUpdate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // deleteDocuments: [], // ** previous results, if to delete
            // documents: [],  // ** results = générés par le contrôle
            connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
            data: JSON.parse(JSON.stringify(data)),
            auditCheckKey: this.acKey,
            // data: JSON.parse(JSON.stringify(this.currentDocumentData)),
            type: "IN_AUDIT_REPORT",
            reviewed: this.reviewed,
        };

        // eslint-disable-next-line no-await-in-loop
        const resultProvision: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        // await this.createUserActivity(action) // deprecated

        this.refresh();
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
            this.refreshGeneralLedger++;
        } else {
            debugger; // git-ignore
        }

        this.initialiseCompany();
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            await this.generalLedger.setAllAccountableAccountsAsAudited();
            await this.validateCapitalChanges("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.generalLedger.setAllAccountableAccountsAsUnaudited();
            await this.validateCapitalChanges("UPDATE");
        }
    }

    disabledDetailsValidateBtn(item) {
        if (this.accountingPeriod && this.accountingPeriod.closed) {
            return true;
            // } else if (!item.carryForward && !item.increases && !item.decreases && !item.balance && !item.comment && !item.validated) {
            //     return true
        }
        if (this.validated) {
            return true;
        }
        return false;
    }

    onQueryDone(data) {
        if (!data.generalLedger?.length) {
            this.showGeneralLedgerCard = false;
        } else {
            this.showGeneralLedgerCard = true;
        }
    }

    expandComment(item) {
        const index = this.expanded?.length
            ? this.expanded.findIndex((e) => e === item.groupName)
            : -1;
        if (index === -1) {
            this.expanded.push(item.groupName);
        } else {
            this.expanded.splice(index, 1);
        }
    }

    addComment(item) {
        const index = this.groupedAccountableAccounts?.length
            ? this.groupedAccountableAccounts.findIndex((caa) => caa.groupName === item.groupName)
            : -1;
        if (index >= 0) {
            this.groupedAccountableAccounts[index].comment = item.comment || "";
        }
    }

    createComments() {
        this.comments = [];

        for (const i of this.groupedAccountableAccounts) {
            if (i.comment) {
                this.comments.push({
                    title: i.groupName + " - " + i.groupDescription,
                    text: i.comment,
                });
            }
        }
    }

    // async fetchTotals(detailledBalanceInfos) {
    //     // this.loading2 = true
    //     if (!detailledBalanceInfos.queryLength) {
    //         remove(this.accountableAccounts, function(aa) {return aa.name === detailledBalanceInfos.aaName})
    //     } else {
    //         if (detailledBalanceInfos.aaName) {
    //             const indexFoundedAA = this.accountableAccounts.findIndex(aa => aa.name === detailledBalanceInfos.aaName)
    //             if (indexFoundedAA >= 0) {
    //                 // const currentAA = this.accountableAccounts[indexFoundedAA]

    //                 this.accountableAccounts[indexFoundedAA].queryLength = detailledBalanceInfos.queryLength
    //                 this.accountableAccounts[indexFoundedAA].aaName = detailledBalanceInfos.aaName
    //                 this.accountableAccounts[indexFoundedAA].totalBalance = detailledBalanceInfos.totalBalance
    //                 this.accountableAccounts[indexFoundedAA].totalCredit = detailledBalanceInfos.totalCredit
    //                 this.accountableAccounts[indexFoundedAA].totalDebit = detailledBalanceInfos.totalDebit
    //             }
    //         }
    //     }
    //     // eslint-disable-next-line no-prototype-builtins
    //     // const fetchsToDo = this.accountableAccounts.find(accAccount => !accAccount.hasOwnProperty('queryLength'))
    //     const fetchsToDo = this.accountableAccounts.find(accAccount => !accAccount.hasOwnProperty('queryLength'))

    //     if (!fetchsToDo) {
    //         this.loading2 = false
    //         // *** if any lines received

    //         this.noResults = !this.accountableAccounts.length
    //         if (!this.acrId) {
    //             this.validateCapitalChanges()
    //         }
    //     }
    // }

    sumsTable(key) {
        // sum data in give key (property)
        const sumSigned = this.groupedAccountableAccounts.reduce((a, b) => a + (b[key] || 0), 0);

        if (key === "carryForward") {
            this.comments.unshift;
        } else if (key === "increases") {
        } else if (key === "decreases") {
        } else if (key === "balance") {
        } else {
            debugger;
        }
        return sumSigned;
    }

    aaExpand(accountableAccount) {
        accountableAccount.expand = !accountableAccount.expand;
    }

    createRows() {
        this.miscellanousOperationData = [];
        const row = {
            date: getDBFormattedDate(this.accountingPeriod.end) || getDBFormattedDate(moment()),
            accountableAccount: { name: "" },
            wording:
                "Regul variation des capitaux " + moment(this.accountingPeriod.end).format("YYYY"),
            netAmount: 0.0,
            debit: 0.0,
            credit: 0.0,
        };

        this.miscellanousOperationData.push(JSON.parse(JSON.stringify(row)));
    }

    toArray(comment) {
        const carriedTexts = comment.split("\n");
        return carriedTexts;
    }

    // ***************** DELETE ACRs **********************
    async deleteAuditCheckResults() {
        if (this.acrId) {
            await this.$apollo.mutate({
                mutation: DELETE_AUDIT_CHECK_RESULTS,
                variables: { id: this.acrId } || {},
            });

            // await this.createUserActivity("DELETE") // deprecated
        }

        this.refresh();
    }

    validateAll() {
        for (const accountableAccount of this.groupedAccountableAccounts) {
            accountableAccount.validated = true;
        }
        this.validated = true;
        this.validateCapitalChanges("VALIDATE");
    }

    unvalidateAll() {
        for (const accountableAccount of this.groupedAccountableAccounts) {
            accountableAccount.validated = false;
        }
        this.validated = false;
        this.validateCapitalChanges("UPDATE");
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
    }

    initialiseCompany() {
        // this.currentDocACRid = ""
        // this.previousDocumentsIds = []
        this.loading = false;
        this.validated = false;
        // this.valid = false;

        // this.showTable = false
        this.showComments = false;
        this.showGeneralLedger = false;

        this.expand = false;
        // this.expand2 = false;
        // this.expand3 = false;
        // this.expanded = []

        this.company = {};
        // this.withAccountingPeriod = false;
        // this.accountingPeriod = null
        // this.periodYear = "";

        // this.selectedCustomer = {};

        // ** dialogs
        // this.provisionsDialog = false;
        // this.unrecoverableLossDialog = false;
        // this.miscellaneousOperationDialog = false

        // ** generalLedger
        // this.totalBalance411NL = 0;

        // * dates
        this.minDate = this.accountingPeriod?.start
            ? this.formatDatePicker(this.accountingPeriod.start)
            : this.formatDatePicker(moment().format("YYYY-MM-DD"));
        this.maxDate = this.accountingPeriod?.end
            ? this.formatDatePicker(this.accountingPeriod.end)
            : this.formatDatePicker(moment().format("YYYY-MM-DD"));
        // this.selectedDate   // ** keep the value of this.selectedDate
        // ERIC DATE TO CHECK BY MONICA

        // ** acr
        this.acrId = "";
        this.acrData = {};
        this.acrResultDocuments = [];

        // this.switchManual = false;
    }
}

export default toNative(CheckCapitalChanges);
</script>
